import { intersection } from 'lodash-es';
import isEmpty from 'lodash-es/isEmpty';
export const MY_FARM_ALLOWED_METRICS = [
    'T_WET',
    'T_DRY',
    'RR',
    'U',
    'T',
    'FF',
    'FXY',
    'DD',
    'DXY',
    'T_SOIL',
    'LW_V',
    'LW_D',
    'SSI',
    'PPFD'
];
/**
 * Checks if a device can be a station on my farm
 */
function canBeAStation(device) {
    return !isEmpty(intersection(device.availableMeasures, MY_FARM_ALLOWED_METRICS));
}
export default canBeAStation;
